module.exports = __webpack_public_path__ + "static/media/limon-2-copy.fdc0fd61.png";